

















import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import { bus } from "../../main";
import { ArticolazioneInfo } from "../../_models/articolazioneInfo";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { userUtils } from "../../_utils/userUtils";
import * as auth from "../../_store/auth.module";
import * as temp from "../../_store/temp.module";
import { AreaInfo } from "../../_models/areaInfo";

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class ElencoColloquiCV extends Vue {
  //   private createParams: object;
  private createDialogParams: object;
  private dataTableParams: any;
  private titleParams: object;

  private listaColloqui: any;
  private listaTurni: any;
  private update: boolean;
  private filters: any;

  constructor() {
    super();
    this.titleParams = {
      title: "ELENCO COLLOQUI CV",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Allievo",
          value: "username",
          sortable: false
        },
        {
          text: "Classe",
          value: "classe",
          sortable: false
        },
        {
          text: "Dettagli Allievo",
          value: "action",
          sortable: false,
          width: "1%"
        },
        {
          text: "Azienda",
          value: "denominazione",
          sortable: false
        },
        {
          text: "Area",
          value: "area"
        },
        {
          text: "Turno Colloquio",
          value: "turnoCV",
          width: "8%"
        },
        {
          text: "Giorno Colloquio",
          value: "giorno"
        },
        {
          text: "Settore",
          value: "articolazione",
          sortable: false,
          width: "1%"
        },
        {
          text: "LinkStanza",
          value: "linkStanza",
          sortable: false
        },
        {
          text: "Allievo Presente",
          value: "allievoPresente",
          width: "1%"
        },
        {
          text: "Azienda Presente",
          value: "aziendaPresente",
          width: "1%"
        },
        {
          text: "Report Colloquio",
          value: "questionarioColloquio",
          sortable: false,
          width: "1%"
        },
        {
          text: "Elimina",
          value: "deleteColloquio",
          sortable: false,
          width: "1%"
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ALLIEVO",
        type: "userTab"
      },
      detailsColloquioDialogParams: {
        title: "REPORT COLLOQUIO",
        type: "infoColloquio"
      },
      filterType: "listaColloqui",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ],
      listaAree: [
        {
          idArea: "Tutte",
          descrizioneArea: "Tutte"
        }
      ],
      listaTurni: [
        {
          idTurno: "Tutti",
          descrizioneTurno: "Tutti"
        }
      ],
      //   colloquioDialogParams: {
      //     title: "QUESTIONARIO COLLOQUIO",
      //     type: "colloquio"
      //   },
      type: "elencoColloqui"
    };
    this.createDialogParams = {
      visible: true,
      type: "nuovoColloquioCV"
    };
    this.listaColloqui = [];
    this.listaTurni = [];
    this.update = false;
    this.filters = null;
  }

  loadAree() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id
    };
    data
      .dispatchAreeIstituto(this["$store"], payload)
      .then(resp => {
        resp.forEach(element => {
          var area: AreaInfo;
          this.dataTableParams.listaAree.push({
            idArea: element.idArea,
            descrizioneArea: element.descrizioneArea
          });
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadTurni() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchTurniColloquiCV(this["$store"], payload)
      .then(result => {
        this.listaTurni = result;
        result.forEach((element: any) => {
          this.dataTableParams.listaTurni.push({
            idTurno: element.idTurno,
            descrizioneTurno: element.turno
          });
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadColloqui() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var userInfo = user.readUserInfo(this["$store"]);
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var count: number = 0;
    if (!userInfo.ruoloUtente.includes(2) && userInfo.ruoloUtente.includes(6)) {
      this.listaColloqui = [];
      this.dataTableParams.records = [];
      data
        .dispatchAssegnazioneArticolazione(this["$store"], userInfo.idUtente)
        .then(resp => {
          resp.forEach(element => {
            var payload = {
              idArticolazione: "",
              idIstituto: instituteInfo.id,
              idAnnoScolastico: idAnnoScolastico
            };
            this.dataTableParams.listaArticolazioni.push(element);
            payload.idArticolazione = element.idArticolazione;
            data
              .dispatchColloquiIstituto(this["$store"], payload)
              .then(result => {
                count++;
                for (let i = 0; i < result.length; i++) {
                  this.listaColloqui.push(result[i]);
                  this.dataTableParams.records.push(result[i]);
                }
                if (count === resp.length) {
                  if (this.update === true) {
                    this.filtraListaColloqui(this.filters);
                  }
                }
              })
              .catch(error => {
                if (error.response.status === 403) {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                }
              });
          });
          bus.$emit("dataLoaded");
        });
    } else {
      var payload = {
        idArticolazione: "",
        idIstituto: instituteInfo.id,
        idAnnoScolastico: idAnnoScolastico
      };
      data
        .dispatchArticolazioni(this["$store"], instituteInfo.id)
        .then(resp => {
          resp.forEach(element => {
            this.dataTableParams.listaArticolazioni.push(element);
          });

          data
            .dispatchColloquiIstituto(this["$store"], payload)
            .then(result => {
              this.listaColloqui = result;
              this.dataTableParams.records = result;
              if (this.update === true) {
                this.filtraListaColloqui(this.filters);
              }
              bus.$emit("dataLoaded");
            })
            .catch(error => {
              if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
              } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              }
            });
        });
    }
  }

  filtraListaColloqui(filters: any) {
    const listaColloqui: any = this.listaColloqui;
    var tempList: any = [];
    var tempList2: any = [];
    var tempList3: any = [];
    this.dataTableParams.records = [];
    listaColloqui.forEach((item: any) => {
      if (filters.fitroArticolazione !== "Tutte") {
        if (filters.fitroArticolazione === "IT01") {
          if (item.articolazione === "IT01") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "IT04") {
          if (item.articolazione === "IT04") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "IT05") {
          if (item.articolazione === "IT05") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "IT10") {
          if (item.articolazione === "IT10") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "IT13") {
          if (item.articolazione === "IT13") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "ITAF") {
          if (item.articolazione === "ITAF") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "ITEN") {
          if (item.articolazione === "ITEN") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "ITET") {
          if (item.articolazione === "ITET") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "ITIA") {
          if (item.articolazione === "ITIA") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "ITMM") {
          if (item.articolazione === "ITMM") {
            tempList.push(item);
          }
        }
        if (filters.fitroArticolazione === "LI03") {
          if (item.articolazione === "LI03") {
            tempList.push(item);
          }
        }
      } else {
        tempList.push(item);
      }
    });
    tempList.forEach((item: any) => {
      if (filters.filtroArea !== "Tutte") {
        if (item.idArea === filters.filtroArea) {
          tempList2.push(item);
        }
      } else {
        tempList2.push(item);
      }
    });
    tempList2.forEach((item: any) => {
      if (filters.filtroTurno !== "Tutti") {
        if (item.idTurno === filters.filtroTurno) {
          tempList3.push(item);
        }
      } else {
        tempList3.push(item);
      }
    });
    this.dataTableParams.records = tempList3;
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    var articolazioniList: ArticolazioneInfo[];
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            // var instituteInfo = user.readInstituteInfo(this["$store"]);
            // data
            //   .dispatchArticolazioni(this["$store"], instituteInfo.id)
            //   .then(response => {
            //     response.forEach(element => {
            //       this.dataTableParams.listaArticolazioni.push(element)
            //     });
            //     // this.loadStudentsList();
            //   });
            this.loadAree();
            this.loadTurni();
            this.loadColloqui();

            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("updateColloquiList", (idColloquio: number) => {
      // this.listaColloqui = []
      // this.dataTableParams.records.forEach((element:any) => {
      //   this.listaColloqui.push(element)
      // });
      var records = this.dataTableParams.records;
      var records2 = this.listaColloqui;
      var index = -1;
      var index2 = -1;
      for (var i = 0; i < records.length; i++) {
        if (records[i].idColloquio === idColloquio) {
          index = i;
          break;
        }
      }
      for (var l = 0; l < records2.length; l++) {
        if (records2[l].idColloquio === idColloquio) {
          index2 = l;
          break;
        }
      }
      records.splice(index, 1);
      records2.splice(index2, 1);
      this.dataTableParams.records = records;
      this.listaColloqui = records2;
    });

    bus.$on("loadColloquiList", async (filters: any) => {
      this.update = true;
      this.filters = filters;
      this.loadColloqui();
    });

    bus.$on("filtroColloquiCV", (filters: any) => {
      this.filtraListaColloqui(filters);
    });
  }
}
